import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import ApolloProvider from './providers/ApolloProvider';
import configureStore from './store/store';

export const store = configureStore();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
    <ApolloProvider>
      <App />
    </ApolloProvider>
    </Provider>
  </React.StrictMode>
);
